require('./leagueLookInService');

angular.module('app.shared.leagueLookIn.leagueLookInController', [
  'app.shared.leagueLookIn.leagueLookInService'
])
  .controller('app.shared.leagueLookIn.leagueLookInController', [
    '$scope',
    '$timeout',
    'app.shared.leagueLookIn.leagueLookInService',
    'FIREBASE_CREDS',
    'leaguestatFirebaseService',
    function ($scope, $timeout, leagueLookInService, fbCreds, lsFb) {
      "use strict";

      $scope.langId = 1;

      /**
       * @type {Game}
       */
      $scope.activeGame = $scope.activeGame || null;
      $scope.league = null;
      $scope.activeSlide = 0;
      $scope.gamesPerSlide = 6;
      $scope.slides = [];

      let games = null;

      let init = function () {
        if ($scope.activeGame) {
          leagueLookInService
            .retrieve($scope.activeGame.igameid)
            .then(function (response) {
              $scope.league = response.data.league;
              games = response.data.games;

              buildSlides();

              // If it's a leaguestat game, watch firebase for updates
              if ($scope.activeGame.iscoringproviderid_fk === 5 || $scope.activeGame.iscoringproviderid_fk === 7) {
                lsFb.authenticate(fbCreds.leaguestat.firebaseUrl, fbCreds.leaguestat.firebaseApiKey, fbCreds.leaguestat.firebaseToken);

                // Initialize firebase
                let updateGoalSummaryWithFbData = function (fbGameGoalSummaryData) {
                  if (fbGameGoalSummaryData) {
                    updateLookinGameScores(fbGameGoalSummaryData);
                  }
                };

                angular.forEach(games, function (game) {
                  lsFb.subscribeToGameGoalSummary(game.league.strleaguestatclientcode, game.iscoringprovidergameid, $scope.langId, updateGoalSummaryWithFbData);
                  $scope.$on('$destroy', function () {
                    lsFb.unsubscribeFromGameGoalSummary(game.league.strleaguestatclientcode, game.iscoringprovidergameid, $scope.langId, updateGoalSummaryWithFbData);
                  });
                });
              }
            });
        }
      };

      // Update the live lookin scores with data from firebase
      let updateLookinGameScores = function (fbGoalSummary) {
        $timeout(function () {
          angular.forEach(games, function (game) {
            if (game.iscoringprovidergameid === fbGoalSummary.GameId) {
              game.HomeGoals = fbGoalSummary.HomeGoalTotal;
              game.AwayGoals = fbGoalSummary.VisitorGoalTotal;
              return;
            }
          });
        });
      };

      let buildSlides = () => {
        $scope.slides = [];
        let i;

        if (games) {
          for (i = 0; i < games.length; i += $scope.gamesPerSlide) {
            $scope.slides.push(games.slice(i, i + $scope.gamesPerSlide));
          }
        }
      };

      $scope.spoiled = false;
      $scope.$on('enableGameSpoiler', function (event, data) {
        $scope.spoiled = data;
      });

      $scope.$on('updateLiveLookin', function (event, data) {
        if (data && data.game) {
          $scope.activeGame = data.game;
        }

        init();
      });

      $scope.$watch(
        () => {
          if ($scope.activeGame) {
            return $scope.activeGame.ileagueid_fk;
          }
        },
        () => {
          init();
        }
      );

      $scope.$watch(
        () => {
          return $scope.gamesPerSlide;
        },
        () => {
          buildSlides();
        }
      );
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/shared/leagueLookIn/leagueLookInController.js